import {Element} from "@api/models/Element";
import {ElementInterface} from "@api/models/interfaces/ElementInterface";
import {RecordingFile} from "@share/web-conferences/types/RecordingFile";

export class WebConferencesRecordings extends Element {
    schemaId: string;
    objectId: string;
    cname: string;
    baseUrl: string;
    uid: string;
    resourceId: string;
    sid: string;
    isDone: boolean;
    filesList: RecordingFile[];

    constructor(data: ElementInterface, schema = '') {
        super(data, schema);
    }
}
